import React, { useContext, useEffect } from 'react';
import { Col, Row, Tabs, Typography } from 'antd';

import AssetGroupAllocations from './AssetGroupAllocations';
import AssetClassLimits from './AssetClassLimits';
import MetricsSelector from './MetricsSelector';
import BenchmarkSelector from './Benchmarks/BenchmarkSelector';
import SessionInstrumentsSelector from './SessionInstrumentSelector';
import OtherSettings from './OtherSettings';
import LeverageSettings from './LeverageSettings';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchEligibleBenchmarkOptions,
  HISTORICAL_SCENARIO,
  retrieveUnderlyingAssets,
  selectors,
} from 'state';
import LimitMetricSettings from './LimitMetricSettings';
import MetricsLimits2 from './MetricsLimits2';
import HistoricalTimeChange from './HistoricalTimeChange';
import MinimumReserveRequirement from './MinimumReserveRequirement';
import GeneralSetup from './GeneralSetup';
import PerSectorAlphaSettings from './PerSectorAlphaSettings';
import AssetsTab from '../../AdminDashboard/Data/AssetsTab/AssetsTab';
import EquitiesTab from '../../AdminDashboard/Data/Equities';
import IndexFundsTable from './Benchmarks/IndexFundsTableNonModal';
import { TrainerSessionContext } from '../TrainerSessionContext';
import OtherSettings2 from './OtherSettings2';

const SessionSettings: React.FC = () => {
  const dispatch = useDispatch();
  const trainerContext = useContext(TrainerSessionContext);

  const session = useSelector(selectors.activeSession);
  useEffect(() => {
    dispatch(retrieveUnderlyingAssets({}));
  }, [dispatch]);

  useEffect(() => {
    if (!session?.id) {
      return;
    }
    dispatch(fetchEligibleBenchmarkOptions({ session_id: session.id }));
  }, [dispatch, session?.id]);

  return (
    <Row gutter={80} style={{ flexFlow: 'row nowrap' }}>
      <Col
        span={5}
        style={{
          minWidth: 330,
          display: 'flex',
          flexDirection: 'column',
          gap: 30,
        }}
      >
        <GeneralSetup />
        <AssetGroupAllocations />
        <AssetClassLimits />
        <LeverageSettings />

        {/*I think metric_limit is deprecated? */}
        {session.limit_metric !== null && <LimitMetricSettings />}
        {session.client_money && <MinimumReserveRequirement />}
      </Col>
      <Col
        span={7}
        style={{
          minWidth: 480,
          borderLeft: '2px solid #eeeeee',
          display: 'flex',
          flexDirection: 'column',
          gap: 30,
        }}
      >
        <PerSectorAlphaSettings />
        <BenchmarkSelector />
        {/*<AssetClassLimits />*/}
        {/*<MetricsSelector />*/}
        <MetricsLimits2 allowEditing={true} />
        <OtherSettings2 />
        {/*<OtherSettings />*/}
      </Col>
      <Col span={12} style={{ borderLeft: '2px solid #eeeeee' }}>
        <Tabs
          // defaultActiveKey="instrument_selection"
          activeKey={trainerContext.activeKey} // <- controlled
          onChange={k => trainerContext.setActiveKey(k as any)} // <- user clicks
        >
          <Tabs.TabPane
            key="instrument_selection"
            tab={
              <Typography.Title level={4}>Session Instruments</Typography.Title>
            }
          >
            <SessionInstrumentsSelector />
          </Tabs.TabPane>
          <Tabs.TabPane
            key="available_benchmark_options"
            // tab="Benchmark"
            tab={
              <Typography.Title level={4}>
                Available Benchmarks Options
              </Typography.Title>
            }
          >
            {/*<AssetsTab />*/}
            {/*<BenchmarkSelector />*/}
            <IndexFundsTable />
          </Tabs.TabPane>
        </Tabs>
      </Col>
    </Row>
  );
};

export default SessionSettings;
